<template>
  <div :class="['tw-py-16', `tw-bg-[${vars.backgroundColor}]`]">
    <div class="tw-container tw-mx-auto tw-px-4">
      <h2 class="heading-h2-size mg-bottom-12px tw-text-center">{{ vars.titleText }}</h2>
      
      <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-6 tw-pt-8">
        <div v-for="(item, index) in items" :key="index" class="tw-flex tw-flex-col tw-w-full sm:tw-w-[calc(50%-12px)] lg:tw-w-[calc(25%-18px)] tw-max-w-[320px] tw-items-center">
            <library-image :src="String(item.photo || '')" :w-ratio="0.78" :h-ratio="1"></library-image>
          
          <div class="tw-py-2 tw-flex tw-flex-col tw-items-center tw-h-full">
            <h3 class="tw-text-xl tw-mb-4 tw-flex-grow tw-line-clamp-2 tw-min-h-[60px] tw-h-[60px]">{{ item.title }}</h3>
            <nuxt-link :external="true" :to="item.link" class="w-button" :class="`${vars.buttonTypeText}`">
              {{ item.label }}
            </nuxt-link>
          </div>
        </div>
      </div>

      <div class="tw-flex tw-justify-center tw-mt-12" v-if="vars.buttonLinkUrl">
        <nuxt-link :external="true" :to="vars.buttonLinkUrl" class="w-button" :class="`${vars.buttonTypeText}`">
          {{ vars.buttonLabelText }}
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  name: 'GuideCardSection',

  mixins: [ComponentMixin],

  computed: {
    items() {
      return this.groupedVariables.items;
    },
  },
});
</script>

<style scoped>
a:hover {
  color: unset !important;
}
</style>